// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__G8g_3"};